import Card from "./components/Card"
import './styles/how_work.css'
function HowWork() {

    const init_cards = [
        {
            title: "Registrati su HEQA",
            text: "Bastano pochi minuti per creare il tuo profilo.",
            img: "https://media.swipepages.com/2023/3/622b5dae96edea001154e697/demure-female-graphic-designer-working-at-her-desk-1.webp"
        },
        {
            title: "Stabilisci il valore del tuo tempo",
            text: "Definisci il prezzo per i tuoi video saluti.",
            img: "https://media.swipepages.com/2023/3/622b5dae96edea001154e697/demure-girl-with-a-suitcase-is-going-somewhere-looking-at-her-phone-150.webp"
        },
        {
            title: "Ricevi richieste e guadagna",
            text: "I fan ti contattano direttamente e tu monetizzi con facilità.",
            img: "https://media.swipepages.com/2023/3/622b5dae96edea001154e697/demure-girl-works-at-her-desk.webp"
        },
        {
            title: "Lascia il segno",
            text: 'Ogni video che registri diventa un ricordo speciale per i tuoi fan."',
            img: "https://media.swipepages.com/2023/3/622b5dae96edea001154e697/demure-man-works-on-his-laptop-while-sitting-in-a-chair.webp"
        }
    ]

    return (
        <div className="how-work">
            <h2>Come funziona</h2>
            <p>HEQA ti offre un nuovo modo per monetizzare la tua musica e rafforzare il legame con i tuoi fan.</p>
            <p> Offri contenuti esclusivi e guadagna fino all’80% per ogni video saluto venduto.</p>
            <div className="card-container">
                {
                    init_cards.map((el) => <Card info={el} />)
                }
            </div>
        </div>
    )

}

export default HowWork